const bodyScrollLock = require('body-scroll-lock');

window.openPopup = function (selector) {
    let wrapper = $(selector),
        scroll = wrapper.find('.bn_popup__scroll').get(0),
        overlay = wrapper.find('.bn_popup__overlay');

    bodyScrollLock.disableBodyScroll(scroll, {reserveScrollBarGap: true});

    overlay.addClass('open');

    $('body').addClass('modal-open');
}

window.closePopup = function (selector) {
    let wrapper = $(selector),
        scroll = wrapper.find('.bn_popup__scroll');

    scroll.removeClass('open');

    bodyScrollLock.enableBodyScroll(scroll.get(0));

    $('body').removeClass('modal-open');

    if (wrapper.hasClass('reload')) {
        window.location.reload()
    }
}

$(document).on('click', '.bn_popup__close-action', function () {
    let that = $(this),
        selector = that.parents('.bn_popup');

    closePopup('#' + selector.attr('id'));
});

$(document).on('click', '.bn_popup__overlay', function (event) {
    let that = $(this),
        selector = that.parents('.bn_popup');

    if (that.hasClass('static')) return;

    if ($(event.target).closest('.bn_popup__wrapper').length) return;

    if (!that.hasClass('open')) return;

    closePopup('#' + selector.attr('id'));
});